<div class="flex">
  <div class="h-52 w-4/5 grid justify-items-center mt-3">
    <p
      class="font-bold text-3xl inline-block align-text-bottom mt-5"
      id="heading"
    >
      404 Page Not Found
    </p>
    <p class="tds-detail-04 tds-text-blue-500"></p>

    <tds-message variant="information" header="Information">
      The request url does not exists.Please click on homepage to continue.
    </tds-message>
  </div>
</div>
